import { Model } from "@vuex-orm/core";
import Chat from "./Chat";
import ChatLookup from "./ChatLookup";
import User from "./User";

export default class ChatMessage extends Model {
  static entity = "chatMessages";

  static fields() {
    return {
      createdAt: this.attr(),
      id: this.attr(),
      isDirty: this.boolean(false),
      chatId: this.number(),
      isInbound: this.boolean(true),
      userId: this.number().nullable(),
      message: this.string(),

      chat: this.belongsTo(Chat, "chatId"),
      chatLookup: this.belongsTo(ChatLookup, "chatId"),
      user: this.belongsTo(User, "userId")
    };
  }

  static mutators() {
    return {
      createdAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      updatedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      }
    };
  }
}
